import { render, staticRenderFns } from "./curriculumPlan.vue?vue&type=template&id=2ac471f0&scoped=true"
import script from "./curriculumPlan.vue?vue&type=script&lang=js"
export * from "./curriculumPlan.vue?vue&type=script&lang=js"
import style0 from "./curriculumPlan.vue?vue&type=style&index=0&id=2ac471f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac471f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac471f0')) {
      api.createRecord('2ac471f0', component.options)
    } else {
      api.reload('2ac471f0', component.options)
    }
    module.hot.accept("./curriculumPlan.vue?vue&type=template&id=2ac471f0&scoped=true", function () {
      api.rerender('2ac471f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/curriculumPlan.vue"
export default component.exports